module.exports = __webpack_public_path__ + "img/048-cosmetics.a16bb18a.svg";